import { createSelector } from 'reselect'
import { getPageParams } from 'selectors/page'

export const getSearch = createSelector(
  getPageParams,
  (pageParams): Record<string, any> => pageParams.search || ''
)
